import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const HomeLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.home',
    link: '/home',
    icon: 'navigation-link__home',
});